import { text } from '../text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBed, faBath, faRulerCombined } from '@fortawesome/free-solid-svg-icons';
import { colors } from '../constants/colors';
// import { PropertyType, RoomType } from "../src\types\types.tsx";
import { PropertyType, RoomType } from "../../src/types/types";
import React, { useEffect } from 'react';
import { BlockHeading } from '../components/BlockHeading';
import { formatIndianNumber } from '../environment';


// type Props = {
//     review: any;
//     isLast: boolean;
// };
type Props = {
    review: PropertyType;
    isLast: boolean;
};


interface Room {
  no_of_beds: number;
  room_type_id: string;
  room_type_name: string;
}

interface RoomTypes {
  [key: string]: Room[];
}

interface Review {
  room_types: RoomTypes;
}

export const FlatPrices: React.FC<Props> = ({ review, isLast }) => {


    useEffect(()=>{
        // console.log(review, "review .............")
    }, [])
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                marginTop: 10,
                marginBottom: isLast ? 0 : 24,
                backgroundColor: '#F9FAFC',
                borderRadius: 10,
                padding: '20px 16px',
                border: '1px solid #E0E0E0',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
                gap: 16,
                position: 'relative',
            }}
        >
                <div>
                  <p style={{ margin: 0, marginBottom:"10px", fontWeight: 600, fontSize:"14px" }}>Starting from</p>
                  <h4 style={{ 
                        color: 'var(--secondary-color)', 
                        fontWeight: 600, 
                        margin: '4px 0 0 0', 
                        fontSize: '21px' 
                      }}>
                    {/* ₹{review.minimum_rent} / month */}

                    ₹{formatIndianNumber(review?.minimum_rent)} / month
                  </h4>
                </div>


            {/* Property Info */}
            {/* <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: 5,
                    borderTop: '1px solid #F0F0F0',
                    gap: 12, // add some spacing
                }}
            >
                <InfoItem label="Private Room" />
                <div style={{ color: '#ccc' }}>|</div>
                <InfoItem label="Single Sharing" />
                <div style={{ color: '#ccc' }}>|</div>
                <InfoItem label="Double Sharing" />
                <div style={{ color: '#ccc' }}>|</div>
                <InfoItem label="Triple Sharing" />
            </div> */}

            {/* <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: 5,
                    borderTop: '1px solid #F0F0F0',
                    gap: 12,
                    flexWrap: 'wrap',
                }}
            >
                {review.room_types.map((room, idx, arr) => (
                    <React.Fragment key={room.room_type_id}>
                        <InfoItem label={`${room.room_type_name}`} />
                        {idx < arr.length - 1 && <div style={{ color: '#ccc' }}>|</div>}
                    </React.Fragment>
                ))}

            </div> */}
{/* <h1 style={{fontSize:"16px", fontWeight:"bold"}}>Room Type Option :</h1> */}
<div
  style={{
    display: "grid",
gridTemplateColumns: "repeat(2, 1fr)", 
    gap: 4,
  }}
>
  {Object.entries(
    review.room_types as unknown as {
      [key: string]: {
        no_of_beds: number;
        room_type_id: string;
        room_type_name: string;
      }[];
    }
  ).map(([typeKey, rooms]) => {
    const roomNames = rooms.map((r) => r.room_type_name);

    // Map typeKey to readable heading
    const headingMap: Record<string, string> = {
      "1": "Single Sharing",
      "2": "Double Sharing",
      "3": "Triple Sharing",
      "4": "Multi Sharing",
    };
    const headingLabel = `${headingMap[typeKey] || "Unknown"}`;

    return (
      <div
        key={typeKey}
        style={{
          border: "1px solid #e0e0e0",
          padding: "12px 5px",
          background: "#ffffff",
          display: "flex",
          flexDirection: "column",
          gap: 6,
          borderRadius: 6,
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          transition: "transform 0.2s, box-shadow 0.2s",
          cursor: "pointer",
        }}
         >
        {/* Card heading */}
        <strong
          style={{
            fontSize: 15,
            fontWeight: 600,
            color: "#9c8989ff",
            marginBottom: 4,
            textAlign:"center"
          }}
        >
          {headingLabel}
        </strong>

     {/* <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 6 }}>
  {roomNames.map((name, idx) => (
    <React.Fragment key={idx}>
      <span style={{ fontSize: 14, color: "#555" }}>{name}</span>
      {idx < roomNames.length - 1 && <span style={{ color: "#ccc" }}>|</span>}
    </React.Fragment>
  ))}
</div> */}

      </div>
    );
  })}
</div>






        </div>
    );
};

// Extract reusable InfoItem component for clarity
const InfoItem = ({ icon, label }: { icon?: any, label: string }) => {
    // Split the label at the first space
    const [first, ...rest] = label.split(' ');
    const second = rest.join(' ');

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '0 2px' }}>
            {icon && <FontAwesomeIcon icon={icon} style={{ color: '#777', fontSize: 14, marginBottom: 4 }} />}
            <text.T16 style={{ color: '#444', textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold', fontSize: 14 }}>{first}</div>
                {second && <div style={{ fontSize: 14 }}>{second}</div>}
            </text.T16>
        </div>
    );
};








// ****************** OLD CARD UI 07-06-2025 ***********************

// import { text } from '../text';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBed, faBath, faRulerCombined } from '@fortawesome/free-solid-svg-icons';
// import { colors } from '../constants/colors';

// type Props = {
//     review: any;
//     isLast: boolean;
// };

// export const FlatPrices: React.FC<Props> = ({ review, isLast }) => {
//     return (
//         <div
//             style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 marginTop: 10,
//                 marginBottom: isLast ? 0 : 24,
//                 backgroundColor: '#F9FAFC',
//                 borderRadius: 10,
//                 padding: '20px 16px',
//                 border: '1px solid #E0E0E0',
//                 boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
//                 gap: 16,
//                 position: 'relative',
//             }}
//         >
//             {/* Price and Room Type */}
//             <div>
//                 <text.H4 style={{ color: '#4B3FEC', fontWeight: 600, marginBottom: 4 }}>
//                     ₹{review.amount}/month &nbsp;
//                     <span style={{ fontSize: 14, color: '#888' }}>({review.roomtype})</span>
//                 </text.H4>
//                 <text.T18 style={{ color: '#666' }}>
//                     <span style={{ color: '#AAA' }}>{review.address}</span>
//                 </text.T18>
//             </div>

//             {/* Property Info */}
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 paddingTop: 12,
//                 borderTop: '1px solid #F0F0F0'
//             }}>
//                 <InfoItem icon={faBed} label={`${review.totalbeds} beds`} />
//                 <InfoItem icon={faBath} label={`${review.totabatrooms} baths`} />
//                 <InfoItem icon={faRulerCombined} label={`${review.area} sq.ft`} />
//             </div>
//         </div>
//     );
// };

// // Extract reusable InfoItem component for clarity
// const InfoItem = ({ icon, label }: { icon: any, label: string }) => (
//     <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//         <FontAwesomeIcon icon={icon} style={{ color: '#777', fontSize: 14 }} />
//         <text.T16 style={{ color: '#444' }}>{label}</text.T16>
//     </div>
// );









// OLD CARD UI

// import { text } from '../text';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBed, faBath, faRulerCombined } from '@fortawesome/free-solid-svg-icons';
// import { colors } from '../constants/colors';

// type Props = {
//     review: any;
//     isLast: boolean;
// };

// export const FlatPrices: React.FC<Props> = ({ review, isLast }) => {
//     return (
//         <div
//             style={{
//                 display: 'flex',
//                 flexDirection: 'column',
//                 marginBottom: isLast ? 0 : 20,
//                 backgroundColor: '#F9FAFC',
//                 borderRadius: 6,
//                 padding: 15,
//                 border: '1px solid #EFEEFB',
//                 gap: 12,
//                 position: 'relative'
//             }}
//         >
//             {/* Top Row: Title and Security Deposit */}
//             <div style={{ display: 'flex', justifyContent: 'flex-end', position: "absolute", zIndex: 1, right: 12 }}>
//                 <text.H4 style={{ color: colors.darkTextColor, fontWeight: 'bold' }}>
//                     ₹{review.securtydeposit} Deposit
//                 </text.H4>
//             </div>

//             {/* Middle Content */}
//             <div>
//                 <text.H4 style={{ color: '#7065F0', fontWeight: 'bold' }}>₹{review.amount}/month  ({review.roomtype})</text.H4>
//                 <text.T18 style={{ color: '#333' }}>
//                     <span style={{ color: '#BFBDBB' }}>{review.address}</span>
//                 </text.T18>
//             </div>

//             {/* Bottom Row */}
//             <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                     <FontAwesomeIcon icon={faBed} style={{ color: '#555' }} />
//                     <text.T16>{review.totalbeds} beds</text.T16>
//                 </div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                     <FontAwesomeIcon icon={faBath} style={{ color: '#555' }} />
//                     <text.T16>{review.totabatrooms} baths</text.T16>
//                 </div>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                     <FontAwesomeIcon icon={faRulerCombined} style={{ color: '#555' }} />
//                     <text.T16>{review.area} sq.ft</text.T16>
//                 </div>
//             </div>
//         </div>
//     );
// };




